import * as React from 'react';
import { observer } from 'mobx-react';

export interface IAlertModalProps {
    title: string;
    message: string;
    OnClose: () => void;
}

@observer
export default class AlertModal extends React.Component<IAlertModalProps> {
    constructor(props: IAlertModalProps) {
        super(props);
        this.onClose = this.onClose.bind(this);
    }

    render(): React.ReactNode {
        return (
            <div className="pxl-modal alert-modal">
                <div className="pxl-modal__content">
                    <div className="flex-heading">
                        <h1 className="pxl-header-sm">{this.props.title}</h1>
                        <button className="close no-btn-style" onClick={this.onClose}>
                            <i className="icon-cancel pxl-text-c11-5" />
                        </button>
                    </div>
                    <div className="flex-row">
                        {this.props.message}
                    </div>
                    <div className="pxl-text-right pxl-margin-top-xlarge">
                        <button
                            onClick={this.onClose}
                            className="pxl-btn pxl-btn--primary pxl-margin-left-large"
                        >
                            OK
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    private onClose(): void {
        this.props.OnClose();
    }
}